import type { Guide } from '../types';

/**
 * S-24.10-09 — „przeczytane” osobno i „nieaktualne” dla rozwiązanych alertów (decyzja użytkownika 21.10.2026,
 * C37; makieta FTL p. Mariusza; scenariusz e2e 28). Dane pokazowe z `e2e/setup/seed-e2e.ts` (`g3Trade2410`):
 * przy DEMO/2026/10/G32 alert „zmiana w TMS po obsadzeniu” potwierdzony na karcie (nieaktualny) i drugi,
 * jeszcze aktualny. Nagrywarka tylko wybiera filtr, niczego nie oznacza.
 */
export const guide: Guide = {
  flagKey: 'notificationReadState',
  title: 'Powiadomienia: „przeczytane” osobno i „nieaktualne” dla rozwiązanych alertów',
  whatItDoes:
    'Każde powiadomienie można oznaczyć jako przeczytane osobno — przyciskiem „Oznacz jako przeczytane” albo przejściem do zlecenia z dzwonka; „Oznacz wszystkie jako przeczytane” zostaje. Alert, którego sprawa jest już załatwiona — potwierdzona zmiana w TMS, rozpatrzony wniosek (także wniosek o wyjątek od bramki publikacji), zlecenie, które dostało auto — nie znika, tylko dostaje znacznik „nieaktualne” i przestaje być wyróżniony jako ważny. Licznik w dzwonku liczy tylko nieprzeczytane i aktualne — nieaktualne go nie podbijają, nawet nieprzeczytane. Na stronie „Powiadomienia” filtr „Aktualność” pokazuje aktualne, nieaktualne albo wszystkie.',
  audience: ['planista FTL', 'Team Leader (planista główny)', 'Trade', 'administrator'],
  presentationItems: ['S-24.10-09'],
  steps: [
    {
      route: '/notifications',
      target: 'history-stale',
      title: 'Znacznik „nieaktualne” i filtr „Aktualność”',
      description:
        'Rozwiązany alert zostaje w historii ze znacznikiem „nieaktualne” — niezależnie od tego, czy był przeczytany. Filtr „Aktualność” zawęża listę do aktualnych albo nieaktualnych.',
      action: 'Otwórz „Powiadomienia” i wybierz w „Aktualność” „nieaktualne”.',
      recorder: {
        account: 'master',
        actions: [{ kind: 'select', label: 'Aktualność', option: 'nieaktualne' }],
      },
    },
    {
      route: '/notifications',
      target: 'history-mark-read',
      title: '„Oznacz jako przeczytane” jednej pozycji',
      description:
        'Przy każdym nieprzeczytanym powiadomieniu jest „Oznacz jako przeczytane”; kliknięcie numeru zlecenia też oznacza je jako przeczytane. Pozostałe zostają nieprzeczytane — przy aktualnym powiadomieniu licznik w dzwonku zmniejsza się o jeden (nieaktualnych licznik i tak nie liczy).',
      action: 'Kliknij „Oznacz jako przeczytane” przy wybranym powiadomieniu.',
      recorder: { account: 'master' },
    },
  ],
};
